@if (workplaceId) {
  <p-card>
    <app-table
      #personsTable
      [gridData]="$any(store.data.workplaceResponsiblePersons$ | async)"
      [columns]="columns"
      translatePrefix="workplace.responsiblePersons."
      [tableTitle]="'workplace.responsiblePersons.title'"
      [hideCheckboxes]="true"
      (createCallback)="openCreateResponsiblePerson()"
      (detailCallback)="openEditResponsiblePerson($event)"
      (deleteCallbackWithEvent)="delete($event)"
      [refreshCallback]="store.api.getWorkplaceResponsiblePersons"
      [additionalFilter]="personsAdditionalFilter"
      [defaultSorters]="[{ column: 'validFrom', direction: 'DESC' }]"
    ></app-table>
  </p-card>
}

<p-dialog
  header="{{ ('workplace.responsiblePersons.form.' + (form.controls.id.value ? 'edit' : 'create') + 'Header') | translate }}"
  [(visible)]="modalVisible"
  [modal]="true"
  [maximizable]="false"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeModal()"
  >
  <div class="grid-1col input-grid-gaps">
    <app-date-input [form]="form" id="validFrom"></app-date-input>
    <app-select-user
      [form]="form"
      id="userId"
    ></app-select-user>
    <app-text-area-input
      id="note"
      [form]="form"
      label="workplace.responsiblePersons.form.note"
    ></app-text-area-input>
  </div>

  <ng-template pTemplate="footer">
    <app-action-buttons (primaryClickEvent)="submit()" (secondaryClickEvent)="closeModal()"></app-action-buttons>
  </ng-template>
</p-dialog>
